/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardVulnerabilitySummaryRegionResponse {
    getFixupPrototypeFunction() { return SecurityDashboardVulnerabilitySummaryRegionResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardVulnerabilitySummaryRegionResponse>): SecurityDashboardVulnerabilitySummaryRegionResponse {
        let obj = Object.assign(new SecurityDashboardVulnerabilitySummaryRegionResponse(), model);
        SecurityDashboardVulnerabilitySummaryRegionResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardVulnerabilitySummaryRegionResponse>): SecurityDashboardVulnerabilitySummaryRegionResponse {
        if (!model) return null;
        return SecurityDashboardVulnerabilitySummaryRegionResponse.newInstance(<SecurityDashboardVulnerabilitySummaryRegionResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardVulnerabilitySummaryRegionResponse) {
        if (!obj) return;

        models.SecurityDashboardVulnerabilitySummaryRegionResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardVulnerabilitySummaryRegionResponse): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardVulnerabilitySummaryRegionResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary_by_cloudprovider) {
            for (let val of this.summary_by_cloudprovider) {
                models.SecurityDashboardVulnerabilityRegionCount.fixupPrototype(val);
            }
        }
    }

    /**
     * Visibility of the vulnerabilities by Account
     */
    summary_by_cloudprovider: Array<models.SecurityDashboardVulnerabilityRegionCount>;

}
